export enum DashboardRouteNameEnum {
	dashboard = "dashboard",
	devices = "dashboard.devices",

}
